import React, { useEffect, useState } from 'react'
import backPackImg from '../../images/backpack.png'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { easyPlayerHasWordsState } from '../../globalStates/gameMain/playerHasWordsContent';
import { useRecoilState, useRecoilValue } from 'recoil';
import { backpackDisplayState } from '../../globalStates/general/backpackDisplay';
import { sentenceState } from '../../globalStates/gameMain/sentence';
import { countWords } from './fieldFunction';
import { useMedia } from 'use-media';



const BackPack = (props) => {
  const [displayWords, setDisplayWords] = useRecoilState(easyPlayerHasWordsState);
  const [backpackDisplay, setBackpackDisplay] = useRecoilState(backpackDisplayState);
  const [backpackStatus, setBackpackStatus] = useState("close");
  const sentence = useRecoilValue(sentenceState);
  const isPC = useMedia({ minWidth: '1000px' });
  const handleClick = () => {
    setBackpackStatus("open");
    setBackpackDisplay("block");
    const tmpDisplayWords = [];
    props.playerHasWords.forEach((data, i) => {
      tmpDisplayWords.push(<p key={`words${i}`}>{data.contents}</p>);
    });
    setDisplayWords(tmpDisplayWords);
  }
  const handleBackPackClose = () => {
    setBackpackStatus("close");
    setTimeout(() => {
      if (backpackStatus === "open") setBackpackDisplay("none");
    }, 500);
  }

  const backpackAreaStyle = css`
      z-index: 2;
      margin-top: 40px;
      position: relative;
    `;
  const backpackImgStyle = css`
    display: ${backpackDisplay === "block" ? "none" : "block"};
    cursor: pointer;
    position: absolute;
    top: ${isPC ? "-60px" : "60px"};
    right: ${isPC ? "5vw" : "65px"};
    width: 150px;
    height: auto;
    animation: fadeIn 0.5s ease;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    `;
  const wordDisplayArea = css`

.displayWord {
  padding: 20px;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    width: 30vw;
    min-height: 300px;
  }

}
@keyframes fadeOut {
  0% {
    width: 30vw;
    height: 300px;
  }
  100% {
    height: 0;
    width: 0;
  }

}
#open {
  display: block;
  #closeBtn {
    display: block;
  }
  animation: fadeIn 0.5s ease;
  width: 30vw;
  min-height: 300px;
}

#close {
  .displayWord {
    display: none;
  }
  #closeBtn {
    display: none;
  }
  animation: fadeOut 0.5s ease;
}
display: ${backpackDisplay};
font-size: 20px;
text-align: center;
position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
-webkit-backdrop-filter: blur(3px);
backdrop-filter: blur(5px);
background-color: rgba(191, 212, 235, 0.5);
z-index: 2;

span {
  display: block;
  position: relative;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

span::before, span::after { /* 共通設定 */
content: "";
position: absolute;
top: 50%;
left: 50%;
width: 2px; /* 棒の幅（太さ） */
height: 25px; /* 棒の高さ */
background: #4c5661;
}
span::before {
  transform: translate(-50%,-50%) rotate(45deg);
}

span::after {
  transform: translate(-50%,-50%) rotate(-45deg);
}
`;

  //　閉じるボタンの位置を調整
  const wrapper = css`
    position: absolute;
    right: 15px;
    top: 10px;
    `;

  // 集める必要のある単語の数
  const wordsLen = countWords(sentence)
  return (
    <>

      <div css={wordDisplayArea}>
        <div id={backpackStatus}>
          <div css={wrapper}>
            <span onClick={handleBackPackClose} id='closeBtn'></span>
          </div>
          <div className='displayWord'>
            {displayWords.length === 0 ? "取得済みの単語はありません。" : displayWords}<br /><br />
            あと{wordsLen - displayWords.length}語です。
          </div>
        </div>
      </div>
      <div css={backpackAreaStyle}>
        <img src={backPackImg} alt="リュックの画像" css={backpackImgStyle} onClick={() => handleClick()} />
      </div>
    </>
  )
}
export default BackPack
